import CardPopups from './modules/card-popups';
import AidCookies from './modules/cookies';

var documentReady = function () {
    AidCookies();
    CardPopups();
};

if (
    document.readyState === 'complete' ||
    (document.readyState !== 'loading' && !document.documentElement.doScroll)
) {
    documentReady();
} else {
    document.addEventListener('DOMContentLoaded', documentReady);
}
